define( 'toolkit/btn/btn', ['toolkit/b-toolkit/b-toolkit'], function(toolkit) {
'use strict';

	return toolkit.create( 'btn', {
		/**
		 *
		 */
		init: function() {
			this._tapHandler = this._onTap.bind(this);
			this._initElems();
		},

		onRender: function() {
			this._initElems();
		},

		_initElems: function() {
			this.$el.off('tap', this._tapHandler);
			this.$el.on('tap', this._tapHandler);
		},

		_onTap: function() {
			/**
			 * для кнопок в виде тэга <a>
			 * нужно дизейблить поведение
			 *
			 * причем на click это не распространяется, т.к. используем только tap
			 */
			if (this.hasMod('disabled')) {
				event.preventDefault();
			}
		},

		/**
		 * Включает или выключает кнопку.
		 * @param {boolean} value
		 * true – включает
		 * false – выключает
		 */
		toggle: function(value) {
			this.$el.toggleMod('disabled', !value);

			return this;
		},

		/**
		 * Делает кнопку главной (main) или побочной.
		 * @param {boolean} value
		 * true – включает
		 * false – выключает
		 */
		toggleActive: function(value) {
			this.$el.toggleMod('active', value);
			if (this.$el.hasMod('mainness')) {
				this.$el.toggleMod('main', value);
			}

			return this;
		}
	} );
});
